<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar" class="sidebar-container">
            <div class="shadow-bottom"></div>

            <perfect-scrollbar id="sidebar-menu" class="list-unstyled menu-categories" tag="ul"
                :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">

                <li class="menu">
                    <router-link to="/" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-home">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                            </svg>
                            <span>{{ $t('Dashboard de Cursos') }}</span>
                        </div>
                    </router-link>
                </li>

                <li v-if="isAuthenticated" class="menu">
                    <router-link to="/cursos" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polygon points="5 3 19 12 5 21 5 3"></polygon>
                        </svg>
                        <span>{{ $t('Meus cursos') }}</span>
                        </div>
                    </router-link>
                </li>
            </perfect-scrollbar>

        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const isAuthenticated = computed(() => store.getters['auth/isAuthenticated']);

onMounted(() => {
    if (window.innerWidth < 992) {
        const savedState = localStorage.getItem('sidebar_state_mobile');
        if (savedState !== null) {
            const shouldBeOpen = savedState === 'true';
            if (store.state.is_show_sidebar !== shouldBeOpen) {
                store.commit('toggleSideBar', shouldBeOpen);
            }
        } else if (store.state.is_show_sidebar) {
            store.commit('toggleSideBar', false);
        }
    }
});

const toggleMobileMenu = () => {
    if (window.innerWidth < 991) {
        store.commit('toggleSideBar', false);
    }
};
</script>

<style scoped>
.sidebar-container {
    display: flex;
    flex-direction: column;
    height: 86%;
}

#sidebar-menu {
    overflow-y: auto;
}

</style>